import { render, staticRenderFns } from "./UmbFooterCash.vue?vue&type=template&id=04059744&scoped=true"
import script from "./UmbFooterCash.vue?vue&type=script&lang=ts"
export * from "./UmbFooterCash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04059744",
  null
  
)

export default component.exports